'use strict';

exports.__esModule = true;

var _setStatic = require('./setStatic');

var _setStatic2 = _interopRequireDefault(_setStatic);

var _createHelper = require('./createHelper');

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = (0, _createHelper2.default)(setDisplayName, 'setDisplayName', false);


//////////////////
// WEBPACK FOOTER
// ./~/recompose/setDisplayName.js
// module id = 4121
// module chunks = 62